export {generateEncodedSapiLabel} from './generateSapiLabel'
